import { Flex, Text } from '@chakra-ui/react'
import React from 'react'

import { useEmptyDetailViewStyles } from './componentStyles/EmptyDetailView.style'

interface EmptyDetailViewProps {
  message: string
}
export const EmptyDetailView = ({ message }: EmptyDetailViewProps) => {
  const styles = useEmptyDetailViewStyles()
  return (
    <Flex css={styles.container}>
      <Text css={styles.text}>{message}</Text>
    </Flex>
  )
}
